import { format, formatISO } from "date-fns"

export const getDateFilterText = (startDate, endDate) => {
  if (startDate && !endDate) {
    return `Due Date After: ${format(startDate, "MM/dd/yyyy")}`
  } else if (endDate && !startDate) {
    return `Due Date Before: ${format(endDate, "MM/dd/yyyy")}`
  } else if (endDate && startDate) {
    return `Due Date Between: ${format(startDate, "MM/dd/yyyy")} - ${format(
      endDate,
      "MM/dd/yyyy"
    )}`
  }
}

export const handleStartDateChange = (date, setter) => {
  const newStartDateString = date
    ? formatISO(date, { representation: "date" })
    : ""
  setter(newStartDateString)
}

export const handleEndDateChange = (date, setter) => {
  const newEndDateString = date
    ? formatISO(date, { representation: "date" })
    : ""
  setter(newEndDateString)
}

export const invoiceSourceIcon = (parentRecordKind) => {
  switch (parentRecordKind) {
    case "contract":
      return "md-description"
    case "reservation":
      return "calendar-month"
    case "sale":
      return "cart-outline"
  }
}

export const invoiceStatusIcon = (invoiceSettledStatus) => {
  switch (invoiceSettledStatus) {
    case "disputed":
    case "failed":
      return "icon-exclamation-circle font-bold"
    case "past_due":
      return "icon-schedule text-lg"
    case "refunded":
      return "icon-refresh text-lg"
    case "settled":
      return "icon-sf-check text-xs"
  }
}

export const invoiceStatusClasses = (invoiceSettledStatus) => {
  switch (invoiceSettledStatus) {
    case "processing":
    case "processing_refund":
    case "refunded":
    case "scheduled":
    case "settled":
      return "text-teal-700"
    case "disputed":
    case "failed":
    case "past_due":
      return "text-red-600"
  }
}
